import axios from 'axios'
import React, { useEffect, useState } from 'react'
import SlidingPane from "react-sliding-pane";
import MaterialTable from 'material-table';
import { toast } from 'react-toastify';
import moment from 'moment';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import authHeader from '../../services/auth-header'
import { API } from '../../backend';
import ButtonLoading from '../Loder/buttonLoading';
import GetNotesService from '../../services/notes/notes';
import { getTrans as t } from "../../Localization/translations"


const NotesSingle = ({
  setIsSidePanelOpen,
  isSidePanelOpen,
  object_name,
  state,
  setNotesLength
}) => {
  const [inputValue, setInputValue] = useState('');

  const tableRef = React.createRef();
  const [isLoadingVal, setIsLoadingVal] = useState(false)
  // const [selectedTags, setSelectedTags] = useState([]); // State variable to store selected tags
  const [allTags, setAllTags] = useState([]);

  const handleAddNotes = () => {
    setIsLoadingVal(true)
    const getuserid = localStorage.getItem('userid')
    GetNotesService.createNotes(state, object_name, inputValue, getuserid)
      .then((res) => {
        if (res.data.success === 1) {
          tableRef.current.onQueryChange();
          setInputValue('')
          toast.success(`${res.data.response}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })
          setIsLoadingVal(false)
        } else {
          toast.error(`${res.data.error}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })
          setIsLoadingVal(false)
        }
      })
    setIsLoadingVal(false)
  }

  useEffect(() => {
    axios.get(API + `helper/notecontextfilter-view/?object_name=${object_name}`, { headers: authHeader(), })
      .then((res) => {
        setAllTags(res.data.response);
      })
  }, []);

  const handleTagClick = (tag) => {
    setInputValue(inputValue + tag);
  };

  // const handleInputChange = (e) => {
  //   const value = e.target.value;
  //   setInputValue(value);

  //   if (value.endsWith(" ") && value) {
  //     const newTag = value;
  //     setSelectedTags([...selectedTags, newTag]);
  //     // setInputValue("");   
  //   }
  // };
  const handleEditorChange = (event, editor) => {
    const data = editor.getData();
    setInputValue(data);
  };

  return (
    <div>
      <div>
        {isSidePanelOpen &&
          <SlidingPane
            className="some-custom-class sidepanebar"
            isOpen={isSidePanelOpen}
            title="Add Notes"
            subtitle=""
            onRequestClose={() => {
              setIsSidePanelOpen(false);
            }}
          >
            <MaterialTable
              tableRef={tableRef}
              style={{
                backgroundColor: "var(--bs-table-bg)",
                borderBottomWidth: "1px",
                boxShadow:
                  "inset 0 0 0 9999px var(--bs-table-accent-bg)",
              }}
              title={<h5 className="mb-0 tc">{object_name}</h5>}
              columns={[
                {
                  title: `${t("Creation Date")}`,
                  field: "date",
                  headerStyle: {
                    verticalAlign: "inherit",
                    fontWeight: "bold",
                    textAlign: "left",
                  },
                  cellStyle: {
                    textAlign: "left",
                    fontSize: 12,
                  },
                  editable: false,
                  render: (rowData) => (
                    <>
                      {" "}
                      <div className="d-xl-none tc d-md-none d-lg-none">
                        {t("Creation Date and Time")}
                      </div>
                      <div>
                        {rowData.entered_timestamp && moment(rowData.entered_timestamp).format('MM/DD/YYYY hh:mm:ss A')}
                      </div>
                    </>
                  ),
                },
                {
                  title: `${t("Created By")}`,
                  field: "created_by",
                  headerStyle: {
                    verticalAlign: "inherit",
                    fontWeight: "bold",
                    textAlign: "left",
                  },
                  cellStyle: {
                    textAlign: "left",
                    fontSize: 12,
                  },
                  editable: false,
                  render: (rowData) => (
                    <>
                      {" "}
                      <div className="d-xl-none tc d-md-none d-lg-none">
                        {t("Created By")}
                      </div>
                      <div>
                        {rowData.entered_by}
                      </div>
                    </>
                  ),
                },
                {
                  title: `${t("Notes")}`,
                  field: "notes_text",
                  render: (rowData) => (
                    <>
                      <div className="d-xl-none tc d-md-none d-lg-none">
                        {t("Notes")}
                      </div>{" "}
                      <div>
                      <div dangerouslySetInnerHTML={{ __html: rowData.notes_text }} />
                        {/* {rowData.notes_text} */}
                      </div>
                    </>
                  ),
                  headerStyle: {
                    verticalAlign: "inherit",
                    fontWeight: "bold",
                    textAlign: "left",
                  },
                  cellStyle: {
                    textAlign: "left",
                    fontSize: 12,
                  },
                },
              ]}
              data={(query) =>
                new Promise((resolve, reject) => {
                  const object_id = state
                  // const object_name = object_name
                  let url = API + `helper/note-view/?`;
                  url += "per_page=" + query.pageSize;
                  url += "&page=" + (query.page + 1);
                  url += "&object_id=" + object_id;
                  url += "&object_name=" + object_name;

                  fetch(url, { headers: authHeader() })
                    .then((response) => response.json())
                    .then((result) => {
                      const reversedData = result.data.reverse();
                      resolve({
                        data: reversedData,
                        page: result.page - 1,
                        totalCount: result.total,
                      });
                    });
                })
              }
              // editable={{
              //   onRowUpdate: (newData, oldData) =>
              //     new Promise((resolve, reject) => {
              //       axios
              //         .post(
              //           API + `helper/note-update/${oldData.id}`,
              //           {
              //             object_id: oldData.object_id,
              //             object_name: oldData.object_name,
              //             notes_text: newData.notes_text
              //           },
              //           { headers: authHeader() }
              //         )
              //         .then((response) => {
              //           toast.success(`${response.data.response}`, {
              //             position: "top-right",
              //             autoClose: 1000,
              //             hideProgressBar: false,
              //             pauseOnHover: true,
              //             draggable: true,
              //             progress: undefined,
              //             theme: "light",
              //           })
              //           resolve();
              //         })
              //         .catch((error) => {
              //           toast.error(error, {
              //             position: "top-right",
              //             autoClose: 1000,
              //             hideProgressBar: false,
              //             pauseOnHover: true,
              //             draggable: true,
              //             progress: undefined,
              //             theme: "light",
              //           })
              //           reject();
              //         });
              //     }),
              //   onRowDelete: (oldData) => new Promise((resolve, reject) => {
              //     axios
              //       .delete(
              //         API + `helper/note-delete/${oldData.id}/`,
              //         { headers: authHeader() }
              //       )
              //       .then((response) => {
              //         toast.success(`${response.data.response}`, {
              //           position: "top-right",
              //           autoClose: 1000,
              //           hideProgressBar: false,
              //           pauseOnHover: true,
              //           draggable: true,
              //           progress: undefined,
              //           theme: "light",
              //         })
              //         resolve();
              //       })
              //       .catch((error) => {
              //         toast.error(error, {
              //           position: "top-right",
              //           autoClose: 1000,
              //           hideProgressBar: false,
              //           pauseOnHover: true,
              //           draggable: true,
              //           progress: undefined,
              //           theme: "light",
              //         })
              //         reject();
              //       });
              //   })
              // }}
              options={{
                headerStyle: {
                  backgroundColor: "white",
                  color: "#245C7F",
                  fontSize: 11,
                },
                rowStyle: (rowData, index) => {
                  if (index % 2) {
                    return { backgroundColor: "#fff" };
                  }
                },
                sorting: true,
                search: false,
                toolbar: true,
                paging: true,
                pageSize: 5, // make initial page size
                emptyRowsWhenPaging: false, // To avoid of having empty rows
                pageSizeOptions: [5, 10, 15, 20, 25],
                paginationType: "stepped",
                showFirstLastPageButtons: false,
                exportAllData: false,
                exportButton: false,
                exportFileName: "Parties",
                actionsColumnIndex: -1,
              }}
            />
            <div className="col-xl-12">
              <div className="row align-items-center" style={{marginTop:'10px'}}>
                <div className="col-lg-9">
                  {/* <input
                    placeholder={t("Enter Note")}
                    className="form-control"
                    type="text"
                    name="note"
                    id="id_note"
                    value={inputValue}
                    onChange={handleInputChange}
                  /> */}
                   <CKEditor
                    editor={ClassicEditor}
                    data={inputValue}
                    onChange={handleEditorChange}
                    onFocus={false}
                    data-cke-filler={false}
                    config={{
                licenseKey: '',  // ✅ blank string, not 'GPL'
                      toolbar: [
                         'undo', 'redo', '|', 'bold', 'italic', 'underline', 'strikethrough', '|',
                        'bulletedList', 'numberedList', 'link', '|',
                        'heading', 'blockQuote', 'codeBlock'
                      ],
                      heading: {
                        options: [
                          { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                          { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                          { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                          { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' }
                        ]
                      }
                    }}

                  />
                </div>
              </div>
                <div className="col-lg-3">
                  <button type="button" className="btn btn-primary" style={{ marginTop: '13px' }}
                    onClick={handleAddNotes}>
                    {
                      isLoadingVal ?
                        <ButtonLoading /> : 'Add Note'

                    }
                  </button>
                </div>
              <div style={{ marginTop: '10px' }}>
                {allTags.map((tag, index) => (
                  <React.Fragment key={index}>
                    {index > 0 && <span style={{ margin: '0 5px' }}>&bull;</span>}
                    <span
                      style={{
                        backgroundColor: '#f0f0f0',
                        padding: '5px 10px',
                        borderRadius: '20px',
                        cursor: 'pointer'
                      }}
                      onClick={() => handleTagClick(tag.context_value)}
                    >
                      {tag.context_value}
                    </span>
                  </React.Fragment>
                ))}
              </div>
            </div>


          </SlidingPane>
        }

      </div>
    </div>
  )
}

export default NotesSingle